@if (showAdvisor()) {
    @if (advisor()) {
        <ng-container *ngTemplateOutlet="advisorKnown"></ng-container>
    } @else {
        <div data-testid="advisor-unknown" class="ap-margin-bottom-2 ap-display-block">
            <h3>{{ 'contact.info.advisor.title' | apContent }}</h3>
            <ap-icon-link data-testid="advisor-icon" iconName="advisor" [link]="'contact.info.advisor.unknown.url' | apContent">
                {{ 'contact.info.advisor.unknown' | apContent }}
            </ap-icon-link>
        </div>
    }
} @else {
    <div data-testid="customer-support">
        <h3>{{ 'contact.info.customer.support.title' | apContent }}</h3>
        @if (phoneNumber) {
            <ap-phone-link
                data-testid="customer-support-icon"
                [text]="'contact.info.customer.support.telephone.message' | apContent: { phoneNumber: phoneNumber }"
                [phoneNumber]="phoneNumber"
            ></ap-phone-link>
        }
        @if (contactPage) {
            <p class="ap-small" [innerHTML]="contactPage"></p>
        }
        <p [innerHTML]="'contact.info.businessHours' | apContent" class="ap-extra-small"></p>
    </div>
}

<ng-template #advisorKnown>
    <div data-testid="advisor-known">
        <h3>{{ 'contact.info.advisor.title' | apContent }}</h3>
        <ap-phone-link
            icon="advisor"
            [text]="'contact.info.advisor.known.telephone.message' | apContent: { phoneNumber: (advisor().phoneNumber | apPhone) }"
            [phoneNumber]="advisor().phoneNumber"
            data-testid="advisor-icon"
        ></ap-phone-link>
        <ul class="unstyled ap-margin-bottom-0">
            <p class="advisor-info__address ap-extra-small">
                <li>{{ advisor().name }}</li>
                <li>{{ advisor().businessHours }}</li>
            </p>
        </ul>
    </div>
</ng-template>
